import {DWCommand} from '../../../../../../lib/commands/DWCommand'

class TextStyleCommand extends DWCommand {
    execute(params, context) {
        params.editorSession.executeCommand('switch-text-type', {
            textType: this.config.textType
        })
    }
}

export {TextStyleCommand}
